<template>
  <v-form ref="form" class="row ml-0 mr-0">
    <v-text-field class="col-12 col-sm-6 col-lg-3"
                  v-model="searchData.id"
                  label="Numer vouchera"
    ></v-text-field>

    <v-text-field class="col-12 col-sm-6 col-lg-3"
                  v-model="searchData.invoice_number"
                  label="Numer paragonu / faktury"
    ></v-text-field>

    <div class="col-sm-6 col-lg-3">
      <v-autocomplete
        :items="typeList"
        label="Typ"
        data-vv-name="typ"
        v-model="searchData.type_id"
        item-text="name"
        item-value="id"
      ></v-autocomplete>
    </div>

    <div class="col-sm-6 col-lg-3">
      <v-autocomplete
        :items="statuses"
        label="Status"
        data-vv-name="status"
        v-model="searchData.status"
        item-text="name"
        item-value="value"
      ></v-autocomplete>
    </div>

    <v-menu class="col-6 col-lg-3"
            :close-on-content-click="false"
            v-model="created_at_startPicker"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
    >
      <v-text-field
        label="Utworzono: od"
        slot="activator"
        v-model="searchData.created_at_start"
        browser-autocomplete="off"
        @input="searchData.created_at_start = null">
      </v-text-field>
      <v-date-picker v-model="searchData.created_at_start"
                     @input="created_at_startPicker = false"
                     :max="searchData.created_at_due"></v-date-picker>
    </v-menu>

    <v-menu class="col-6 col-lg-3"
            :close-on-content-click="false"
            v-model="created_at_duePicker"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
    >
      <v-text-field
        label="Utworzono: do"
        slot="activator"
        v-model="searchData.created_at_due"
        browser-autocomplete="off"
        @input="searchData.created_at_due = null">
      </v-text-field>
      <v-date-picker v-model="searchData.created_at_due"
                     @input="created_at_duePicker = false"
                     :min="searchData.created_at_start"></v-date-picker>
    </v-menu>

    <v-menu class="col-6 col-lg-3"
            :close-on-content-click="false"
            v-model="expired_at_startPicker"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
    >
      <v-text-field
        label="Wygasa: od"
        v-validate="'required'"
        slot="activator"
        v-model="searchData.expired_at_start"
        browser-autocomplete="off"
        @input="searchData.expired_at_start = null">
      </v-text-field>
      <v-date-picker v-model="searchData.expired_at_start"
                     @input="expired_at_startPicker = false"
                     :max="searchData.expired_at_due"></v-date-picker>
    </v-menu>

    <v-menu class="col-6 col-lg-3"
            :close-on-content-click="false"
            v-model="expired_at_duePicker"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
    >
      <v-text-field
        label="Wygasa: do"
        v-validate="'required'"
        slot="activator"
        v-model="searchData.expired_at_due"
        @input="searchData.expired_at_due = null"
        browser-autocomplete="off">
      </v-text-field>
      <v-date-picker v-model="searchData.expired_at_due"
                     @input="expired_at_duePicker = false"
                     :min="searchData.expired_at_start"></v-date-picker>
    </v-menu>
    <v-menu class="col-6 col-lg-3"
            :close-on-content-click="false"
            v-model="realized_at_startPicker"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
    >
      <v-text-field
        label="Zrealizowano: od"
        slot="activator"
        v-model="searchData.realized_at_start"
        browser-autocomplete="off"
        @input="searchData.realized_at_start = null">
      </v-text-field>
      <v-date-picker v-model="searchData.realized_at_start"
                     @input="realized_at_startPicker = false"
                     :max="searchData.realized_at_due"></v-date-picker>
    </v-menu>

    <v-menu class="col-6 col-lg-3"
            :close-on-content-click="false"
            v-model="realized_at_duePicker"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
    >
      <v-text-field
        label="Zrealizowano: do"
        slot="activator"
        v-model="searchData.realized_at_due"
        browser-autocomplete="off"
        @input="searchData.realized_at_due = null">
      </v-text-field>
      <v-date-picker v-model="searchData.realized_at_due"
                     @input="realized_at_duePicker = false"
                     :min="searchData.realized_at_start"></v-date-picker>
    </v-menu>
    <div class="col-sm-6 col-lg-3" v-if="isAdmin">
      <v-autocomplete
        :items="userList"
        label="Pracownik"
        data-vv-name="pracownik"
        v-model="searchData.employeeId"
      >
        <template
          slot="selection"
          slot-scope="data"
        >
          {{data.item.name}} {{data.item.surname}}
        </template>
        <template
          slot="item"
          slot-scope="{ item }"
        >
          <v-list-tile-content>
            <v-list-tile-title v-text="`${item.name} ${item.surname} ${markAsDeleted(item.deleted_at)}`"></v-list-tile-title>
          </v-list-tile-content>
        </template>
      </v-autocomplete>
    </div>
    <div class="display-flex w-100 justify-content-end">
      <v-btn class="mr-0" color="white" @click="$emit('search',true, searchData)">
        Szukaj
      </v-btn>
    </div>
  </v-form>
</template>

<script>
  export default {
    name: 'VouchersSearch',
    props: {
      typeList: Array,
      userList: Array,
      propsSearchData: Object,
    },
    data() {
      return {
        statuses: [
          {
            value: 'N',
            name: 'Nowe',
          },
          {
            value: 'I',
            name: 'W realizacji',
          },
          {
            value: 'F',
            name: 'Zakończone',
          },
        ],
        realized_at_startPicker: false,
        realized_at_duePicker: false,
        created_at_startPicker: false,
        created_at_duePicker: false,
        expired_at_startPicker: false,
        expired_at_duePicker: false,
        searchData: Object.assign({}, this.$props.propsSearchData),
      };
    },
    computed: {
      isAdmin() {
        return JSON.parse(localStorage.getItem('USERDATA')).type !== 'U';
      },
    },
    methods: {
      markAsDeleted(val) {
        return val ? '[Usunięty]' : '';
      },
    },
  };
</script>

<style scoped>

</style>
